<template>
    <!-- スマホ横画面にしたときに画面が切れてしまう問題の対処でコメントアウト -->
    <!-- <div style="height:100vh;"> -->
    <div style="">
        <div class="setting-area">
            <p class="simple-ttl">電圧監視設定</p>
            <div class="simple-table -col02">
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <p>端末ID</p>
                            </td>
                            <td class="no-border-right">
                                <p class="widget-term-id">{{cameraInfo.term_id}}</p>
                            </td>
                            <td class="no-border-left"></td>
                        </tr>
                        <tr>
                            <td>
                                <p class="-required">シリアル番号</p>
                            </td>
                            <td class="no-border-right">
                                <p class="input-wrap">
                                    <label for="serialNum"></label>
                                    <input v-model="form.serialNum" type="text" id="serialNum" required>
                                </p>
                            </td>
                            <td class="no-border-left">
                                <button class="resetButton" @click="resetWord('serialNum')">クリア</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <button class="change-btn" @click="confirmModifyWidgetInfo()" type="submit">変更を保存</button>
    </div>
</template>
<script>
import commonValidationCheck from '../../js/modules/componentCommonValidationCheck.js';
const apiUrl = process.env.VUE_APP_API_apiUrl;
const valSession = sessionStorage.getItem('set_session');
const queries = { live_access_token: valSession };

export default {
    name: 'SettingWidgetDetailsComponent',
    data(){
        return {
          // 設定情報をformとして渡す情報を保持するdata属性
          form:{
            serialNum: null,
            alertInfo_widgetError: "シリアル番号入力に誤りがあります。"
          },
          routerLink: '/settings?site_no=' + this.$store.getters['auth/getSiteNo']
        }
    },
    props:{
        siteInfo:{
            type: Object
        },
        cameraInfo:{
            type: Object
        }
    },
    methods: {
      resetWord: function (target) {
            if (target === 'serialNum') {
                this.form.serialNum = '';
            }
      },
      //**********************************************************/
      // API実施による情報取得
      /**********************************************************/
      callApiForGetInfo: async function(param){
          // 関数return値を配置する変数
          var isApiData = "";
          await this.$store.dispatch('requestApi/getApiInfoAction', {
              url: apiUrl + param,
              params: queries
          })
          .then(response => { // eslint-disable-line
              this.infoCallingApi = this.$store.getters['requestApi/getApiInfo'];
              isApiData = this.infoCallingApi;
          }, error => {// eslint-disable-line
              if (error == "Error: Request failed with status code 401") {
                  sessionStorage.clear();
                  window.localStorage.removeItem('TodoApp');
                  this.$emit('showResultMessage', {
                      transitionLogoutPageFlg: true,
                      transitionTopPageFlg: false,
                      execFlg: false,
                      message:"エラー",
                      sub_message:"ログインし直してください。",
                      errorFlag: true
                  });
              } else if (error == "Error: Request failed with status code 403") {
                  this.$emit('showResultMessage', {
                      transitionLogoutPageFlg: false,
                      transitionTopPageFlg: true,
                      execFlg: false,
                      message:"権限エラー",
                      sub_message:"アクセス権がありません。",
                      errorFlag: true
                  });
              } else {
                  this.$emit('showResultMessage', {
                      transitionLogoutPageFlg: false,
                      transitionTopPageFlg: false,
                      execFlg: false,
                      message:"電圧監視情報取得失敗",
                      sub_message:"電圧監視情報の取得に失敗しました。",
                      errorFlag: true
                  });
              }
          })
          return isApiData
      },
      //**********************************************************/
      // 電圧監視ウィジェット情報を管理しているテーブルに登録されている電圧監視ウィジェットのシリアル番号を取得する処理
      /**********************************************************/
      // 引数
      // site_no: 現場情報
      // term_id: 端末情報
      /**********************************************************/
      fetchPersonalInfo: async function(site_no, term_id){
        // API実行により、電圧監視ウィジェットのpersonalテーブル情報を抽出する
        const personalInfo = await this.callApiForGetInfo('sites/' + site_no + '/terms/' + term_id + '/personal')
        for (let personalObjNum = 0; personalObjNum < personalInfo.length; personalObjNum++) {
          // 電圧監視ウィジェット情報を管理しているテーブルに登録されている電圧監視ウィジェット用シリアル番号のキーがあった場合の処理
          if(personalInfo[personalObjNum]['opt_key'] === "power_serial_no"){
            this.form.serialNum = personalInfo[personalObjNum]['opt_value']
            break;
          }
        }
      },
      //**********************************************************/
      // form値validation実施処理
      /**********************************************************/
      validationFormValue: function(){
        const form = this.form;
        return {
          serialNum:(!!form.serialNum),
        }
      },
      //**********************************************************/
      // form値validation実施後のform送信ボタンチェック処理
      /**********************************************************/
      isValid: function(){
        const validationFormValue = this.validationFormValue
        return Object.keys(validationFormValue).every(
          key => {
            return validationFormValue[key]
          }
        )
      },
      //**********************************************************/
      // 変更確認ポップアップの表示のために親コンポーネントにある確認ポップアップ表示処理
      /**********************************************************/
      confirmModifyWidgetInfo: function(){
        if((commonValidationCheck.isNumber(this.form.serialNum) || this.form.serialNum === "" || this.form.serialNum === "0")){
          if(!(this.form.serialNum.slice(-1) === " ") && !(this.form.serialNum.slice(-1) === "　")) {
            this.$emit('displayWidgetConfirm')
          } else {
            this.$emit('showResultMessage', {
              transitionLogoutPageFlg: false,
              transitionTopPageFlg: false,
              execFlg: false,
              message:"入力エラー",
              sub_message:"シリアル番号には0以上の整数値を入力してください。",
              errorFlag: true
            });
          }
        } else {
          this.$emit('showResultMessage', {
            transitionLogoutPageFlg: false,
            transitionTopPageFlg: false,
            execFlg: false,
            message:"入力エラー",
            sub_message:"シリアル番号には0以上の整数値を入力してください。",
            errorFlag: true
          });
        }
      },
      //**********************************************************/
      // routerをリロードする処理
      /**********************************************************/
      loadBrowser: function(){
        window.location.href = "./camera?site_no=" + this.$store.getters['auth/getSiteNo'];
      },
      //**********************************************************/
      // 親コンポーネントの変更確認ポップアップの表示後、適用された後の処理実行
      // 親コンポーネントで確認ポップアップを削除している
      /**********************************************************/
      modifyWidgetStatusChange: function () {
        this.updateWidgetInfo(this.siteInfo.site_no, this.cameraInfo.term_id);
      },
      //**********************************************************/
      // 電圧監視ウィジェットの設定情報変更のためのAPI実施処理
      /**********************************************************/
      // 引数
      // site_no: 現場情報
      // term_id: 端末情報
      // serialNum: 電圧監視ウィジェットシリアル番号情報
      /**********************************************************/
      updateWidgetInfo: async function(site_no, term_id) {// eslint-disable-line
        // 関数return値を配置する変数
        var isApiData = "";
        // シリアル番号のバリデーションチェックが成功した場合の処理
        if(this.isValid === false){
          alert(this.alertInfo_widgetError)
        }
        // シリアル番号のバリデーションチェックが失敗した場合の処理
        else {
          // ビュー全体がレンダリングされるまで待つ
          // シリアル番号更新がされるのを待ってから処理を実行する
          this.$nextTick(async function () {
            // 設定情報をputする際に必要となる情報をオブジェクトとして管理
            const queryParam = {// eslint-disable-line
              power_serial_no: this.form.serialNum,
            };
            // live_access_token処理を格納しているオブジェクトに他のクエリパラメータを配置
            const queryParams = Object.assign(queries, queryParam);// eslint-disable-line

            await this.$store.dispatch('requestApi/putApiInfoAction', {
                url: apiUrl + 'power/widget/' + site_no + '/' + term_id,
                params: queryParams
            })
            .then(response => { // eslint-disable-line
                this.infoCallingApi = this.$store.getters['requestApi/putApiInfo'];
                isApiData = this.infoCallingApi;

                // ローディングフィニッシュ
                this.$emit('settingChangeLoadFinish');

                this.$emit('showResultMessage', {
                  transitionLogoutPageFlg: false,
                  transitionTopPageFlg: false,
                  execFlg: true,
                  message:"データ更新成功",
                  sub_message:"データの変更が完了しました。",
                  errorFlag: false
                });
            }, error => {// eslint-disable-line
                // ローディングフィニッシュ
                this.$emit('settingChangeLoadFinish');

                if (error == "Error: Request failed with status code 401") {
                    sessionStorage.clear();
                    window.localStorage.removeItem('TodoApp');
                    this.$emit('showResultMessage', {
                        transitionLogoutPageFlg: true,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"エラー",
                        sub_message:"ログインし直してください。",
                        errorFlag: true
                    });
                } else if (error == "Error: Request failed with status code 403") {
                    this.$emit('showResultMessage', {
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: true,
                        execFlg: false,
                        message:"権限エラー",
                        sub_message:"アクセス権がありません。",
                        errorFlag: true
                    });
                } else {
                    this.$emit('showResultMessage', {
                      transitionLogoutPageFlg: false,
                      transitionTopPageFlg: false,
                      execFlg: false,
                      message:"データ更新失敗",
                      sub_message:"データの変更に失敗しました。",
                      errorFlag: true
                    });
                }
            })
          })
        }
        return isApiData
      }
    },
    mounted: async function() {
      scrollTo(0, 0);
      this.$emit('loadingStarted');

      // 電圧監視ウィジェットのシリアル番号を取得
      await this.fetchPersonalInfo(this.siteInfo.site_no, this.cameraInfo.term_id);

      this.$emit('loadingFinished');

      history.pushState(null, null, null);
      // ブラウザバックを検視した場合にカメラ一覧に戻るようにする
      window.addEventListener('popstate', () => {
        this.$emit('widgetListsDisplay', {execFlg: true});
      });
    },
}
</script>

<style lang="scss" scoped>
</style>